import {
    addMusic, checkIsAllMusicUploaded, checkIsAllPhotosUploaded,
    removeMusic,
    setCurrentMusic, setIsAllMusicUploaded, setIsAllPhotosUploaded,
    setIsMusicPlaying,
    setMusicUploadProgress
} from "../store/makerDataSlice";
import MusicData, {MUSIC_TYPE_USER} from "../Interfaces/MusicData";
import {UploadStatus} from "../Interfaces/SlideData";
import axios, {AxiosProgressEvent} from "axios";
import {getUploadRequestDataUrl} from "./url";
import * as Sentry from "@sentry/react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {SWAL_ALERT_DEFAULTS} from "../Utils/defaults";

export default async function uploadMusic(argsData: any) {

    let file = argsData.file;
    let dispatch = argsData.dispatch;
    let tmpProjectId = argsData.tmpProjectId;
    let pid: string = argsData.pid;
    let makerData = argsData.makerData;

    let vkLaunchParams = {};
    if (makerData?.vkLaunchParams?.vk_app_id) {
        for (const [key, value] of Object.entries(makerData.vkLaunchParams)) {
            // @ts-ignore
            vkLaunchParams[key] = value;
        }
    }

    dispatch(setIsAllMusicUploaded(false));

    dispatch(addMusic({
        id: pid,
        // оставляем исходный filename, убираем спец. символы
        title1: file.name.replace(/[^а-яА-Яa-zA-Z0-9 \-\._+]/g, ''),
        type: MUSIC_TYPE_USER,
        status: UploadStatus.uploading
    } as MusicData));

        // получаем action и поля формы для upload'а файла (это может быть сервер sl или yandex object storage
        const response0 = await axios.get(getUploadRequestDataUrl, {
            params: {
                fileName: file.name,
                tmpProjectId: tmpProjectId,
                pid: pid,
                type: 'sound',
                ...vkLaunchParams
            }
        });

        if (typeof response0.data['error'] !== 'undefined') {
            if (response0.data['error'] === 'wrongFile') {
                throw ({
                    message: 'Failed to upload music. Wrong file. No extension.',
                    response: response0,
                    responseConfig: JSON.stringify(response0?.config),
                    responseData: JSON.stringify(response0?.data),
                    url: getUploadRequestDataUrl
                });
            }
        }

        // отправляем форму с файлом
        let data = new FormData()
        for (const [key, value] of Object.entries(response0.data)) {
            if (key === 'action') {
                continue;
            }
            if (key === 'fileFieldName') {
                // @ts-ignore
                data.append(value, file as Blob, file.name)
            } else {
                // @ts-ignore
                data.append(key, value)
            }
        }

        const response = await axios.post(
            response0.data['action'],
            data,
            {
                onUploadProgress: function (progressEvent: AxiosProgressEvent) {
                    var percentCompleted = progressEvent.total ? Math.round((progressEvent.loaded * 100) / progressEvent.total) : 0
                    dispatch(setMusicUploadProgress({
                        id: pid,
                        uploadProgress: percentCompleted
                    }));
                },
                headers: {"Content-Type": "multipart/form-data"}
            }
        );

        if (response.data.files?.length == 1) {
            if (response.data.files[0]?.size > 0) {
                if (response.data.files[0]?.error) {
                    throw ({
                        message: 'Failed to upload sound. Error in response files.',
                        response: response,
                        responseConfig: JSON.stringify(response?.config),
                        responseData: JSON.stringify(response?.data),
                        url: response0.data['action']
                    });
                }
                const musicData: MusicData = {
                    id: response.data.files[0].pid,
                    url: response.data.files[0].url,
                    // оставляем исходный filename, убираем спец. символы
                    title1: file.name.replace(/[^а-яА-Яa-zA-Z0-9 \-\._+]/g, ''), //response.data.files[0].name,
                    title2: '',
                    duration: response.data.files[0].duration_seconds,
                    type: MUSIC_TYPE_USER,
                    status: UploadStatus.ready,
                    createdAt: Math.round(new Date().getTime() / 1000)
                } as MusicData;
                dispatch(addMusic(musicData));
                dispatch(setCurrentMusic(musicData));
                dispatch(setIsMusicPlaying(true));
                dispatch(checkIsAllMusicUploaded());
            } else {
                throw ({
                    message: 'Failed to upload sound. Error in response files 2.',
                    response: response,
                    responseConfig: JSON.stringify(response?.config),
                    responseData: JSON.stringify(response?.data),
                    url: response0.data['action']
                });
            }
        } else if (typeof response.data.error !== 'undefined') {
            if (response.data.error === 'wrongType') {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    ...SWAL_ALERT_DEFAULTS,
                    title: 'Неверный файл мелодии',
                    text: 'Вы можете загрузить мелодию только в формате MP3',
                    icon: 'error'
                });
                dispatch(removeMusic({id: pid}));
            }
            if (response.data.error === 'wrongAudioFile') {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    ...SWAL_ALERT_DEFAULTS,
                    title: 'Неверный файл мелодии',
                    text: 'Мелодия не воспроизводится, загрузите другой файл.',
                    icon: 'error'
                });
                dispatch(removeMusic({id: pid}));
            }
            if (response.data.error === 'fileTooLarge') {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    ...SWAL_ALERT_DEFAULTS,
                    title: 'Файл слишком большой',
                    text: 'Слишком большой файл. Можно загрузить мелодию размером до 30Мб.',
                    icon: 'error'
                });
                dispatch(removeMusic({id: pid}));
            }
            if (response.data.error === 'fileTooSmall') {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    ...SWAL_ALERT_DEFAULTS,
                    title: 'Мелодия слишком короткая',
                    text: 'Мелодия слишком короткая. Загрузите мелодию длительностью больше 14 секунд.',
                    icon: 'error'
                });
                dispatch(removeMusic({id: pid}));
            }
        } else {
            throw ({
                message: 'Failed to upload sound. Error in response.',
                response: response,
                responseConfig: JSON.stringify(response?.config),
                responseData: JSON.stringify(response?.data),
                url: response0.data['action']
            });
        }
}